export default __webpack_public_path__ + "static/media/DNo.8-2.244686e1.jpg";